import React from 'react';
import '../assets/styles/App.css';
import "@fontsource/montserrat";
import {useAuth} from "../components/Authentication/AuthProvider";
import WhiteNavbar from "../components/Navbars/WhiteNavbar.js";


function Logout() {
    const auth = useAuth();

    React.useEffect(() => {
        auth.logOut();
    }, []);

    document.title = "Sign Out";

    return(<>
        <section>
            <WhiteNavbar/>
        </section>

        <section className="relative pb-20">
            <div className="container relative mx-auto text-center pt-12 px-4">
                <div className="bg-blue-v-light rounded-lg text-blue ">Goodbye</div>
            </div>
        </section>


    </>);
}

export default Logout;